module.exports = __webpack_public_path__ + "img/painted.72a6952b.png";